import {
  EMPLOYMENT_LOADING,
  EMPLOYMENT_SUCCESS,
  EMPLOYMENT_FAILED,
  EMPLOYMENT_ADD_LOADING,
  EMPLOYMENT_ADD_SUCCESS,
  EMPLOYMENT_ADD_FAILED,
  EMPLOYMENT_REMOVE_LOADING,
  EMPLOYMENT_REMOVE_SUCCESS,
  EMPLOYMENT_REMOVE_FAILED,
  EMPLOYMENT_ANSWER_LOADING,
  EMPLOYMENT_ANSWER_SUCCESS,
  EMPLOYMENT_ANSWER_FAILED,
  EMPLOYMENT_SAVE_LOADING,
  EMPLOYMENT_SAVE_SUCCESS,
  EMPLOYMENT_SAVE_FAILED,
  PREVIOUS_EMPLOYMENT_COUNT_LOADING,
  PREVIOUS_EMPLOYMENT_COUNT_SUCCESS,
  PREVIOUS_EMPLOYMENT_COUNT_FAILED,
  EMPLOYMENT_VIA_UAN_LOADING,
  EMPLOYMENT_VIA_UAN_SUCCESS,
  EMPLOYMENT_VIA_UAN_FAILED,
} from "../Constants/employmentConstants";

export const employmentReducer = (state = { employmentData: {} }, action) => {
  switch (action.type) {
    case EMPLOYMENT_LOADING:
      return { loading: true, employmentData: {} };
    case EMPLOYMENT_SUCCESS:
      return { loading: false, employmentData: action.payload };
    case EMPLOYMENT_FAILED:
      return { loading: false, error: action.employmentData };
    default:
      return state;
  }
};

export const employmentAddReducer = (
  state = { employmentAddData: [] },
  action
) => {
  switch (action.type) {
    case EMPLOYMENT_ADD_LOADING:
      return { loading: true, employmentAddData: [] };
    case EMPLOYMENT_ADD_SUCCESS:
      return { loading: false, employmentAddData: action.payload };
    case EMPLOYMENT_ADD_FAILED:
      return { loading: false, error: action.employmentAddData };
    default:
      return state;
  }
};

export const employmentRemoveReducer = (
  state = { employmentRemoveData: [] },
  action
) => {
  switch (action.type) {
    case EMPLOYMENT_REMOVE_LOADING:
      return { loading: true, employmentRemoveData: [] };
    case EMPLOYMENT_REMOVE_SUCCESS:
      return { loading: false, employmentRemoveData: action.payload };
    case EMPLOYMENT_REMOVE_FAILED:
      return { loading: false, error: action.employmentRemoveData };
    default:
      return state;
  }
};

export const employmentQuestionReducer = (
  state = { employmentQuestionData: {} },
  action
) => {
  switch (action.type) {
    case EMPLOYMENT_ANSWER_LOADING:
      return { loading: true, employmentQuestionData: {} };
    case EMPLOYMENT_ANSWER_SUCCESS:
      return { loading: false, employmentQuestionData: action.payload };
    case EMPLOYMENT_ANSWER_FAILED:
      return { loading: false, error: action.employmentQuestionData };
    default:
      return state;
  }
};

export const saveEmploymentReducer = (
  state = { employmentSaveData: {} },
  action
) => {
  switch (action.type) {
    case EMPLOYMENT_SAVE_LOADING:
      return { loading: true, employmentSaveData: {} };
    case EMPLOYMENT_SAVE_SUCCESS:
      return { loading: false, employmentSaveData: action.payload };
    case EMPLOYMENT_SAVE_FAILED:
      return { loading: false, error: action.employmentSaveData };
    default:
      return state;
  }
};

export const previousEmploymentCountReducer = (
  state = { previousEmploymentCountData: [] },
  action
) => {
  switch (action.type) {
    case PREVIOUS_EMPLOYMENT_COUNT_LOADING:
      return { loading: true, previousEmploymentCountData: [] };
    case PREVIOUS_EMPLOYMENT_COUNT_SUCCESS:
      return { loading: false, previousEmploymentCountData: action.payload };
    case PREVIOUS_EMPLOYMENT_COUNT_FAILED:
      return { loading: false, error: action.previousEmploymentCountData };
    default:
      return state;
  }
};


export const employmentViaUANReducer = (state = { employmentViaUANData: {} }, action) => {
  switch (action.type) {
    case EMPLOYMENT_VIA_UAN_LOADING:
      return { loading: true, employmentViaUANData: {} };
    case EMPLOYMENT_VIA_UAN_SUCCESS:
      return { loading: false, employmentViaUANData: action.payload };
    case EMPLOYMENT_VIA_UAN_FAILED:
      return { loading: false, error: action.employmentViaUANData };
    default:
      return state;
  }
};

